<template>
    <div class="card mt-3">
        <div class="card-header bg-success">
            <span style="color: white">Холат</span>
        </div>
        <div class="card-body">
            <ul class="list-group list-group-flush overflow-auto" style="max-height: 300px;">
                <li class="list-group-item text-center">
                    <div class="badge badge-secondary" v-if="realEstate.status==='AssignedToEvaluator'">{{$t("realEstate.status.assignedToEvaluator")}}</div>
                    <div class="badge badge-warning" v-else-if="realEstate.status==='NotFullyEvaluated'">{{$t("realEstate.status.notFullyEvaluated")}}</div>
                    <div class="badge badge-info" v-else-if="realEstate.status==='Evaluated'">{{$t("realEstate.status.evaluated")}}</div>
                    <div class="badge badge-success" v-else-if="realEstate.status==='Confirmed'">{{$t("realEstate.status.confirmed")}}</div>
                    <div class="badge badge-danger" v-else-if="realEstate.status==='Rejected'">{{$t("realEstate.status.rejected")}}</div>
                    <div class="badge badge-danger" v-else>{{$t("realEstate.status.pending")}}</div>
                    <div v-if="realEstate.status==='Confirmed'">Сана: {{realEstate.confirmedDate}}</div>
                </li>
                <li class="list-group-item text-center">
                    <div v-if="realEstate.appraiserReportEsp">Баҳоловчи тамонидан ҳисобот (ЭЦП орқали) <span class="badge badge-info"> Тасдиқланган</span></div>
                    <div v-else>Баҳоловчи тамонидан ҳисобот (ЭЦП орқали) <span class="badge badge-warning"> Тасдиқланмаган</span></div>
                </li>
                <li class="list-group-item text-center">
                    <div v-if="realEstate.directorActInvoiceEsp">Директор тамонидан Ҳисоб варак фактура (ЭЦП оркали) <span class="badge badge-info"> Тасдиқланган</span></div>
                    <div v-else>Директор тамонидан Ҳисоб варак фактура (ЭЦП орқали) <span class="badge badge-warning"> Тасдиқланмаган</span></div>
                </li>
                <li class="list-group-item text-center">
                    <div v-if="realEstate.directorReportEsp">Директор тамонидан ҳисобот (ЭЦП орқали) <span class="badge badge-info"> Тасдиқланган</span></div>
                    <div v-else>Директор тамонидан ҳисобот (ЭЦП оркали) <span class="badge badge-warning"> Тасдиқланмаган</span></div>
                </li>
                <li class="list-group-item text-center">
                    <div v-if="realEstate.espDto">Буюртмачи тамонидан Ҳисоб варак фактура(ЭЦП оркали) <span class="badge badge-info"> Тасдиқланган</span></div>
                    <div v-else>Буюртмачи тамонидан Ҳисоб варак фактура(ЭЦП оркали) <span class="badge badge-warning"> Тасдиқланмаган</span></div>
                </li>
                <li class="list-group-item text-center" v-if="realEstate.invoiceMib">
                    <span class="badge badge-success" v-if="realEstate.invoiceMib.invoiceMIbJsonDirector">{{realEstate.invoiceMib.invoiceMIbJsonDirector}}</span>
                    <span class="badge badge-success" v-if="realEstate.invoiceMib.invoiceMIbJsonClient">{{realEstate.invoiceMib.invoiceMIbJsonClient}}</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            realEstate: Object
        }
    }
</script>

<style scoped>

</style>